import { SelectOptionProps } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { CHANNEL_TYPE_TO_TRANSLATION_KEY } from '../constants';
import { ChannelTypeEnum } from '../types';

export function useChannelTypeOptions(): SelectOptionProps<ChannelTypeEnum>[] {
  const { t } = useTranslation();

  return [
    {
      label: t(CHANNEL_TYPE_TO_TRANSLATION_KEY[ChannelTypeEnum.BACKUP]),
      value: ChannelTypeEnum.BACKUP,
    },
    {
      label: t(CHANNEL_TYPE_TO_TRANSLATION_KEY[ChannelTypeEnum.TERRITORIAL_DISCONNECTION]),
      value: ChannelTypeEnum.TERRITORIAL_DISCONNECTION,
    },
    {
      label: t(CHANNEL_TYPE_TO_TRANSLATION_KEY[ChannelTypeEnum.MAIN_BROADCAST]),
      value: ChannelTypeEnum.MAIN_BROADCAST,
    },
  ];
}
